<template>
    <div class="root flex wrap center vcenter">
        <div class="item flex wrap center vcenter">
            <MetaBox :meta="{
                key: 'mobile',
                type: 'mobile',
                name: 'شماره همراه'
            }" :vm="models['mobile'] || ''" @onchange="onchange"></MetaBox>
        </div>
        <div class="item flex wrap center vcenter">
            <MetaBox :meta="{
                key: 'template',
                type: 'dropdown',
                name: 'قالب‌های آماده',
                extras: 'R0:key=data,value=sms_templates'
            }" :vm="this.models['template'] || ''" @onchange="onchange"></MetaBox>
        </div>
        <div class="item flex wrap center vcenter">
            <MetaBox :meta="{
                key: 'message',
                type: 'textarea',
                name: 'متن پیام'
            }" :vm="models['message'] || ''" @onchange="onchange"></MetaBox>
        </div>
        <div class="item flex wrap center vcenter">
            <Button :meta="{
                key: 'submit',
                name: 'ارسال پیامک'
            }" :active="loading" :disabled="disabled" @onclick="submit"></Button>
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from 'vue'

import Button from '../Form/Button.vue'

/* eslint-disable */
export default {
    name: 'SMS',
    props: ['data'],
    inject: ['base'],
    components: {
        MetaBox: defineAsyncComponent(() => import('../Form/Inputs/MetaBox.vue')),
        Button
    },
    computed: {
        template() {
            return this.models['template']
        }
    },
    data() {
        return {
            models: {},
            errors: {},
            loading: false
        }
    },
    watch: {
        template(newTemplate, oldTemplate) {
            if (this.models['template'])
                this.base.API().get(`Data/Extra/Template?id=${Number(this.models['template'])}`,
                    (response) => {
                        if (this.base.Util().success(response)) {
                            this.models['message'] = response.data.data.content
                        } else
                            this.base.Notification().error({
                                code: response.data.errorCode,
                                referr: obj.entity_type,
                                text: response.data.message
                            })
                    }, (error) => {
                        this.base.Notification().error({
                            code: 5000,
                            text: 'خطایی رخ داد، لطفا مجددا تلاش کنید!'
                        })
                    })
        }
    },
    methods: {
        onchange(obj) {
            this.models[obj.key] = obj.value
            this.errors[obj.key] = obj.error
        },
        submit() {
            if (this.errors['mobile'] || !this.base.Util().validate(this.models['mobile'])) {
                this.base.Notification().error({
                    code: 1000,
                    text: 'شماره همراه'
                })
                return
            }

            if (!this.base.Util().validate(this.models['message'])) {
                this.base.Notification().error({
                    code: 1000,
                    text: 'متن پیام'
                })
                return
            }

            this.loading = true

            this.base.API().post(`Notice/Register`, {
                data: [
                    {
                        uid: '{My:0}',
                        subject: 'پیام کوتاه سریع',
                        body: this.models['message'],
                        note: false,
                        notify: false,
                        sms: true,
                        email: false,
                        summary: this.models['message'],
                        recipients: [this.models['mobile']]
                    }
                ]
            }, (response) => {
                this.loading = false
                if (this.base.Util().success(response)) {
                    this.models = {}
                    this.base.Notification().toast('نتیجه عملیات', 'ارسال با موفقیت انجام شد!', 'success')
                    this.$emit('onresult')
                } else
                    this.base.Notification().error({
                        code: response.data.errorCode,
                        referr: obj.entity_type,
                        text: response.data.message
                    })
            }, (error) => {
                this.loading = false
                this.base.Notification().error({
                    code: 5000,
                    text: 'خطایی رخ داد، لطفا مجددا تلاش کنید!'
                })
            })
        }
    }
}
</script>

<style scoped src="../../assets/css/components/dialogs/sms.css"></style>